// extracted by mini-css-extract-plugin
export default {"container":"UserCard_container__wHN10"};